// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"_404_pageNotFound_1pZmo"};